<template>
  <v-container>
    <v-form>
      <v-card>
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              outlined
              dense
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="categoria.inativar"
              label="Inativar categoria ?"
              color="success"
              v-show="mode === 'save'"
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <form-cat
          :categoria="categoria"
          :mode="mode"
        />
        <v-card>
          <v-tabs
            v-model="tabs"
            height="45"
          >
            <v-tab>
              <v-icon class="mr-2">
                mdi-note-text
              </v-icon>
              Subcategorias
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-card-title>
                        Subcategorias de notícias
                      </v-card-title>
                      <v-data-table
                        :headers="headersSub"
                        :items="subcategorias"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadSub(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadSub(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="loadAddSub"
                          >
                            <v-icon left>
                              mdi-camera
                            </v-icon>
                            Adicionar subcategoria
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-4">
          <v-col
            cols="12"
            md="10"
          >
            <v-btn
              color="success"
              class="mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="space-around">
          <v-col cols="auto">
            <v-dialog
              v-model="dialog"
              transition="dialog-bottom-transition"
              fullscreen
            >
              <template v-slot:default="dialog">
                <v-card>
                  <v-toolbar
                    color="primary"
                    dark
                  >
                    Pesquisar categorias
                  </v-toolbar>
                  <v-card-title>
                    <v-text-field
                      class="search"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Pesquisar"
                      single-line
                      hide-details
                    >
                    </v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="categorias"
                    :search="search"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        medium
                        color="primary"
                        class="mr-2"
                        @click="loadCategoria(item)"
                      >
                        mdi-square-edit-outline
                      </v-icon>
                      <v-icon
                        medium
                        color="error"
                        class="mr-2"
                        @click="loadCategoria(item, 'remove')"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="error"
                      @click="dialog.value = false"
                    >Fechar</v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
        </v-row>
        <v-container>
          <v-dialog
            v-model="addSubcategoria"
            transition="dialog-top-transition"
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Subgrupo de notícias
                </v-toolbar>
                <v-card
                  elevation="2"
                  class="pa-3"
                >
                  <div class="ma-5">
                    <PageTitle
                      icon="mdi-pencil-box-outline"
                      sub="Subcategorias"
                    />
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="2"
                        >
                          <v-text-field
                            v-model="codigo"
                            label="Código"
                            dense
                            filled
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                          v-if="codigo"
                        >
                          <v-checkbox
                            v-model="subcategoria.inativar"
                            label="inativar subcategoria?"
                            color="success"
                            class="mt-0 mb-2"
                            v-show="mode === 'save'"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <form-sub-cat
                        :subcategoria="subcategoria"
                        :mode="mode"
                      />
                    </v-form>
                  </div>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="success"
                      class="mr-4"
                      v-if="codigo"
                      type="submit"
                      @click="addSair"
                    >
                      <v-icon left>
                        mdi-content-save
                      </v-icon>
                      Salvar e sair
                    </v-btn>
                    <v-btn
                      color="success"
                      class="mr-4"
                      v-if="codigo"
                      type="submit"
                      @click="addCont"
                    >
                      <v-icon left>
                        mdi-content-save
                      </v-icon>
                      Salvar e continuar
                    </v-btn>
                    <v-btn
                      color="error"
                      class="mr-4"
                      v-if="codigo"
                      @click="resetSub"
                    >
                      Limpar
                      <v-icon left>
                        mdi-broom
                      </v-icon>
                    </v-btn>
                    <v-btn
                      color="danger"
                      class="mr-4"
                      @click="dialog.value = false"
                    >
                      Sair
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-card>
            </template>
          </v-dialog>
        </v-container>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import FormCat from '../forms/FormCat.vue'
import FormSubCat from '../forms/formSubCat.vue'
export default {
  name: 'CatComponent',
  components: { PageTitle, FormCat, FormSubCat },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    tabs: null,
    codigo: '',
    dialog: false,
    addSubcategoria: false,
    tabela: 'categorias',
    search: '',
    mode: 'save',
    categoria: {},
    categorias: [],
    subcategoria: {},
    subcategorias: [],
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Categoria', value: 'categoria' },
      { text: 'Descrição', value: 'ds_categoria' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersSub: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Subcategoria', value: 'subcategoria' },
      { text: 'Descriçao.', value: 'ds_subcategoria' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    save () {
      const method = this.categoria.id ? 'put' : 'post'
      const id = this.categoria.id ? `/${this.categoria.id}` : ''
      axios[method](`${baseApiUrl}/categorias${id}`, this.categoria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    saveCat () {
      const method = this.subcategoria.id ? 'put' : 'post'
      const id = this.subcategoria.id ? `/${this.subcategoria.id}` : ''
      this.subcategoria.uid_categoria = this.categoria.id
      axios[method](`${baseApiUrl}/subcategorias${id}`, this.subcategoria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetSub()
          this.loadSubcategorias()
        })
        .catch(showError)
    },

    remove () {
      alert('Deseja realmente remover?')
    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data
      })
    },
    loadSubcategorias () {
      const idC = this.categoria.id
      const url = `${baseApiUrl}/subcategorias-da-categoria/${idC}`
      axios.get(url).then(res => {
        this.subcategorias = res.data
      })
    },
    loadCategoria (categoria, mode = 'save') {
      this.mode = mode
      this.categoria = { ...categoria }
      this.codigo = this.categoria.id
      this.dialog = false
      this.loadSubcategorias()
    },
    reset () {
      this.mode = 'save'
      this.categoria = {}
      this.codigo = ''
      this.loadUser()
    },
    resetSub () {
      this.subcategoria = {}
      this.subcategoria.usuario = this.user.id
      this.subcategoria.uuid = uuid.v1()
    },
    loadDialog () {
      this.dialog = true
      this.loadCategorias()
    },
    loadAddSub () {
      this.subcategoria.uuid = uuid.v1()
      this.subcategoria.usuario = this.user.id
      this.addSubcategoria = true
    },
    addCont () {
      this.saveCat()
    },
    addSair () {
      this.saveCat()
      this.addSubcategoria = false
    },
    loadUser () {
      this.categoria.uuid = uuid.v1()
      this.categoria.usuario = this.user.id
    }
  },
  created () {
    this.loadUser()
  }
}
</script>

<style scoped>
.container {
  width: 98% !important;
}
</style>
